import { Button, Typography } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";

const { Paragraph } = Typography;

const CollapsibleText = ({ content, width, style = {} }) => {
  const [hasEllipsis, setHasEllipsis] = useState(false);
  const [expand, setExpand] = useState(null);
  const [key, setKey] = useState(1);

  const toggleExpand = (value = null) => {
    setExpand(value === null ? !expand : value);
    if (!value) {
      setKey(key + 1);
    }
  };

  return (
    <>
      <Paragraph
        key={key}
        style={{
          width: width,
          marginBottom: 0,
          ...style,
        }}
        onClick={() => !!hasEllipsis && toggleExpand()}
        ellipsis={
          !expand
            ? {
                expandable: true,
                symbol: <DownOutlined style={{ fontSize: "10px" }} />,
                onEllipsis: (ellipsis) => setHasEllipsis(ellipsis),
                onExpand: () => toggleExpand(true),
              }
            : false
        }
      >
        {content}
        {expand === true && (
          <Button
            onClick={() => toggleExpand(false)}
            icon={<UpOutlined style={{ fontSize: "10px" }} />}
            type="link"
          />
        )}
      </Paragraph>
    </>
  );
};

export default CollapsibleText;
